import React, { useState, useEffect, useCallback } from 'react';
import SessionManager from '../../routes/SessionManager';
import PeepCamera from '../modals/PeepCamera';
import { Slider } from 'antd';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService'

const PTZControls = ({ show, device_id, zone, setPtzNew }) => {

    const sessionManager = new SessionManager();
    const user = sessionManager.readCookie('user', true);
    let t11;

    const [ptz, setPTZ] = useState({
        pan: "-175.56",
        tilt: "-10.00",
        zoom: "1",
        MinPan: "-180",
        MaxPan: "180",
        MinTilt: "-90",
        MaxTilt: "0",
        MinZoom: "1",
        MaxZoom: "9999",
        device_category: "PTZ",
        actual_device_category: "PTZ"
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getControls();
    }, []);

    const getControls = useCallback(() => {
        controlCamera('info');
    }, []);

    const controlCamera = (operation = 'info', data = {}) => {
        if (!loading)
            setLoading(true);

        const isPTZChanged = Object.keys(data).length > 0;
        const query = isPTZChanged ? Object.entries(data).map(([k, v]) => `${k}=${v}`).join('&') : null;
        if (operation !== 'info')
            setPtzNew({ ...ptz, ...data });

        CommonUtils.ajax({
            url: API.AXIS_CAMERA.BASE + API.PATH_SEPARATOR + operation,
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            headers: {
                user_login: user.user_login,
                user_token: user.user_token
            },
            data: JSON.stringify({ query, device_id }),
        }).then((res) => {
            if (res.status.code === 200) {
                const ptz_new = operation === 'info' ? res.data : { ...ptz, ...data };
                setPTZ(ptz_new);
                setLoading(false);
                if (data.callback) data.callback(false);
            }
        });
    };

    const onZoomIncrementOrDecrement = (operation) => {
        const zoom = parseInt(ptz.zoom);
        const zMin = parseInt(ptz.MinZoom);
        const zMax = parseInt(ptz.MaxZoom);
        const zoomStep = Math.floor((zMax - zMin) / 20);

        const newZoom = operation === "+" ? Math.min(zoom + zoomStep, zMax) : Math.max(zoom - zoomStep, zMin);
        controlCamera('modify', { zoom: newZoom });
    }

    if (!show) return null;

    return (
        <>
            {ptz.actual_device_category === 'PTZ' && <PeepCamera ptz={ptz} controlCamera={controlCamera} zone={zone} />}
            <div style={{ position: 'absolute', top: '50px', right: '5px', background: '#efefef82', borderRadius: '10px', padding: "px 2px", zIndex: 2000 }}>
                <table>
                    <tbody>
                        <tr><td className='text-center py-2' onClick={() => onZoomIncrementOrDecrement("+")}><i className='fa fa-plus cursor-pointer'></i></td></tr>
                        <tr>
                            <td style={{ height: '250px', borderBottom: '1px solid #444', borderTop: '1px solid #444', padding: "5px 0px" }}>
                                <Slider
                                    onChange={(value) => {
                                        clearTimeout(t11);
                                        t11 = setTimeout(() => controlCamera('modify', { zoom: value }), 100);
                                    }}
                                    handleStyle={{ background: '#6c32b4', borderColor: '#6c32b4', boxShadow: '0px 0px 8px white' }}
                                    trackStyle={{ background: '#6c32b4', borderColor: '#6c32b4' }}
                                    max={parseInt(ptz.MaxZoom)}
                                    min={parseInt(ptz.MinZoom)}
                                    vertical
                                    value={parseInt(ptz.zoom) || 1}
                                />
                            </td>
                        </tr>
                        <tr><td className='text-center py-2' onClick={() => onZoomIncrementOrDecrement("-")}><i className='fa fa-minus cursor-pointer'></i></td></tr>
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default PTZControls;